import { render } from "./Uploader.vue?vue&type=template&id=4ce28d07"
import script from "./Uploader.ts?vue&type=script&lang=js"
export * from "./Uploader.ts?vue&type=script&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=4ce28d07&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__